// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rygxY","select":"styles_select__2F3rw"};